













































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwSlider } from '../sw-slider';
import { TimeObj } from './types';
import { CSSStyleOptions } from '../common-types';
import moment from 'moment';

const i18nPathPrefix = 'libShared.SwDatetimePicker';

@Component({
  components: {
    SwSlider,
  },
})
export default class SwTimePicker extends SwExtendedVue {
  @Prop({ type: String, default: '00:00:00' })
  value: string;

  @Prop({ type: Boolean, default: false })
  enableRange: boolean;

  @Prop({ type: Boolean, default: false })
  disableMin: boolean;

  @Prop({ type: Boolean, default: false })
  disableSec: boolean;

  cssPrefix = 'sw-timepicker';
  i18nPathPrefix = i18nPathPrefix;

  hour: number = 0;
  min: number = 0;
  sec: number = 0;

  hourEnd: number = 0;
  minEnd: number = 0;
  secEnd: number = 0;

  mounted() {
    this.updateTimeObj();
  }

  @Watch('value')
  updateTimeObj() {
    const timeRange = this.value.split('->');
    if (timeRange.length > 1) {
      const timeEnd = this.parseTime(timeRange[1].split(':'));
      this.hourEnd = timeEnd.hour;
      this.minEnd = timeEnd.min;
      this.secEnd = timeEnd.sec;
    }
    const timeStart = this.parseTime(timeRange[0].split(':'));
    this.hour = timeStart.hour;
    this.min = timeStart.min;
    this.sec = timeStart.sec;
  }

  parseTime(timeStr: string[]): TimeObj {
    const timeArr: number[] = timeStr.map((time) => { return Number(time); });
    return {
      hour: timeArr[0] !== undefined ? timeArr[0] : 0,
      min: timeArr[1] !== undefined ? timeArr[1] : 0,
      sec: timeArr[2] !== undefined ? timeArr[2] : 0,
    };
  }

  @Watch('hour')
  @Watch('min')
  @Watch('sec')
  @Watch('hourEnd')
  @Watch('minEnd')
  @Watch('secEnd')
  updateTimeValue() {
    if (this.pane === 1 && this.hour === 24) {
      this.min = 0;
      this.sec = 0;
    }
    if (this.hourEnd === 24) {
      this.minEnd = 0;
      this.secEnd = 0;
    }
    this.$emit('input', this.timeStr);
  }

  // if disabledMin, then disableSec also.
  get effectiveDisableSec(): boolean {
    return this.disableMin || this.disableSec;
  }

  get timeStr() {
    const timeFormat = `HH:mm${!this.effectiveDisableSec ? ':ss' : ''}`;
    // 2000-1-1 is just a placeholder..
    const startTime: moment.Moment = moment(`2000-1-1 ${this.hour}:${this.min}:${this.sec}`);
    const endTime: moment.Moment = moment(`2000-1-1 ${this.hourEnd}:${this.minEnd}:${this.secEnd}`);
    const startDayCondition = this.pane === 1 && timeFormat === 'HH:mm' && this.hour === 24 ? '24:00' :
     (this.pane === 1 && timeFormat === 'HH:mm:ss' && this.hour === 24) ? '24:00:00' : startTime.format(timeFormat);
    const endDayCondition = timeFormat === 'HH:mm' && this.hourEnd === 24 ? '24:00' : timeFormat === 'HH:mm:ss' && this.hourEnd === 24 ?
     '24:00:00' : endTime.format(timeFormat);
    return `${startDayCondition}->${endDayCondition}`;
  }

  get pane() {
    return this.enableRange ? 2 : 1;
  }

  get blockWidth() {
    return `${this.pane * 228}px`;
  }

  get paneHeight(): CSSStyleOptions {
    const labelNum = 1 + +!this.disableMin + +!this.effectiveDisableSec;
    return {
      height: `${labelNum * 33}px`,
    };
  }

}
